<template>
  <div :class="$style.edit">
    <div :class="$style.topRight">
      <button class="btn mini" @click="deleteItem()" v-if="selected.title">Delete</button>
    </div>
    <form v-on:submit.prevent="save">
      <div :class="$style.formControl">
        <label for="title">Title</label>
        <ui-input v-model="selected.title" />
      </div>
      <div :class="$style.formControl">
        <label for="slug">Sub-Title</label>
        <ui-input v-model="selected.subtitle" />
      </div>
      <div :class="$style.formControl">
        <label for="tag">Tags (seperated by comma)</label>
        <ui-input v-model="tags" />
      </div>
      <div :class="$style.formControl">
        <label for="label">Long Description (displays underneath the title)</label>
        <textarea v-model="selected.intro" rows="4"></textarea>
      </div>
      <div :class="$style.formControl">
        <label for="image">Thumbnail Image URL</label>
        <ui-input v-model="selected.img" />
        <div :class="$style.thumb">
          <img :src="selected.img" />
        </div>
      </div>
      <div :class="$style.formControl">
        <label for="video">Video ID</label>
        <ui-input v-model="selected.video" />
      </div>
      <div :class="$style.formControl">
        <label for="type">Video Source</label>
        <v-select v-model="videoType" :options="videoTypeOptions"></v-select>
      </div>
      <div :class="$style.formControl">
        <label for="index">Index (used for sorting)</label>
        <ui-input v-model="selected.index" />
      </div>
      <div :class="$style.formControl">
        <label for="type">Type</label>
        <v-select v-model="type" :options="typeOptions"></v-select>
      </div>
      <div :class="$style.formControl">
        <label for="category">Parent Category</label>
        <v-select v-model="category" :options="getCategories()"></v-select>
      </div>
      <div :class="$style.formControl">
        <label for="type">Product</label>
        <v-select v-model="product" :options="productOptions"></v-select>
      </div>
      <div :class="$style.resources">
        <h3>Resource Items <div class="btn sm" @click="newResource()">Add New</div></h3>
        <div :class="$style.items" v-for="(item, index) in selected.items">
          <div :class="$style.resourceItem">
            <div :class="$style.delete" @click="removeResource(index)"> X </div>
            title:
            <ui-input v-model="item.title" />
            url:
            <ui-input v-model="item.url" />
          </div>
        </div>
      </div>
      
      <div :class="$style.formControl">
        <button class="btn" type="submit">Save All Changes</button>
        <button class="btn" @click="saveAsNew()">Save As New</button>
      </div>
    </form>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import uiInput from '../../lib/Form/Input'
  import database from '../../../database'
  import _filter from 'lodash/filter'
  import _find from 'lodash/find'
  import _map from 'lodash/map'
  import _set from 'lodash/set'
  import _each from 'lodash/each'
  import Vue from 'vue'
  import constants from '../../../constants'
  import product from '../../../api/product'

  export default {
    name: 'edit',
    components: {
      vSelect,
      uiInput
    },
    data () {
      return {
        selected: {},
        type: '',
        category: '',
        product: '',
        tags: [],
        productOptions: [],
        videoType: '',
        typeOptions: [
          { label: 'Lesson', value: 'module' },
          { label: 'Folder', value: 'category' }
        ],
        videoTypeOptions: [
          { label: 'Youtube', value: 'youtube' },
          { label: 'Wistia', value: 'wistia' }
        ]
      }
    },
    watch: {
      $route (to, from) {
        if (to.params.id) {
          var vc = this
          database
            .getSingle(['academy', 'lessons', to.params.id])
            .then(function (data) {
              vc.selected = data
            })
        }
      },
      selected (newVal) {
        if (newVal) {
          this.type = _find(this.typeOptions, {value: this.selected.type})
          this.videoType = _find(this.videoTypeOptions, {value: this.selected.videoType})
          this.category = _find(this.getCategories(), {value: this.selected.category})
          this.tags = Array.isArray(newVal.tags) ? newVal.tags.join(', ') : null
          this.product = _find(this.productOptions, {value: this.selected.product})
        }
      },
      type (newVal) {
        if (newVal) {
          console.log('type changed', newVal)
          this.selected.type = newVal.value
        }
      },
      videoType (newVal) {
        if (newVal) {
          this.selected.videoType = newVal.value
        }
      },
      category (newVal) {
        if (newVal) {
          console.log('category changed', newVal)
          this.selected.category = newVal.value
        }
      },
      product (newVal) {
        if (newVal) {
          this.selected.product = newVal.value
        }
      },
      tags (newVal) {
        if (newVal) {
          console.log('tags changed', newVal)
          var tagArray = []
          _each(newVal.split(','), function (tag) {
            tagArray.push(tag.trim())
          })
          this.selected.tags = tagArray
        } else {
          this.selected.tags = null
        }
      }
    },
    methods: {
      save () {
        if (this.selected.id) {
          console.log('Save', this.selected.id)
          var vc = this
          database.update(['academy', 'lessons', this.selected.id], this.selected).then(function () {
            vc.$toasted.show('Changes were Saved', {
              duration: 3000,
              className: 'toasty'
            })
            vc.selected = {}
          }).catch(function (err) {
            this.$toasted.show('Error: ' + err, {
              duration: 3000,
              className: 'toasty'
            })
          })
        } else {
          this.$toasted.show('Nothing Saved! Fields are empty...', {
            duration: 3000,
            className: 'toasty'
          })
        }
      },
      saveAsNew () {
        if (this.selected.title && this.selected.img) {
          if (confirm('Are you sure you want to create a new record?')) {
            var now = new Date().getTime()
            var id = '_' + now + Math.floor(Math.random() * 1000)
            var newLesson = this.selected
            newLesson.id = id
            console.log('saving to new', id)
            var vc = this
            database.update(['academy', 'lessons', id], newLesson).then(function () {
              vc.$store.commit(constants.NEW_LESSON, newLesson)
              vc.$toasted.show('Your new record has been created', {
                duration: 3000,
                className: 'toasty'
              })
              vc.selected = {}
            })
          }
        }
      },
      deleteItem () {
        var vc = this
        database.set(['academy', 'lessons', this.selected.id], null).then(function () {
          vc.$toasted.show('Record has been deleted', {
            duration: 3000,
            className: 'toasty'
          })
          vc.selected = {}
        })
      },
      newResource () {
        var newIndex = '_' + new Date().getTime() + Math.floor(Math.random() * 1000)
        if (this.selected.items) {
          Vue.set(this.selected.items, newIndex, {
            title: '',
            url: '',
            icon: 'fa-file-pdf-o'
          })
        } else {
          Vue.set(this.selected,
            'items',
            _set({},
              newIndex, {
                title: '',
                url: '',
                icon: 'fa-file-pdf-o'
              }))
        }
      },
      removeResource (id) {
        console.log('delete', id)
        Vue.delete(this.selected.items, id)
        this.$toasted.show('Resource has been removed', {
          duration: 3000,
          className: 'toasty'
        })
      },
      getCategories () {
        var data = this.$store.state.training.lessonsSrc
        var list = _map(
          _filter(data, function (i) {
            return i.type === 'category'
          }),
          function (i) {
            return { label: i.title, value: i.id }
          }
        )
        list.unshift({ label: 'TOP LEVEL', value: 'academy' })
        return list
      }
    },
    mounted () {
      var vc = this
      // get list of available products
      product
        .list()
        .then(function (products) {
          vc.productOptions = products.map(function (item) {
            return {label: item, value: item}
          })
        })
    }
  }
</script>

<style lang="scss" module>
  @import './style.scss'
</style>


// WEBPACK FOOTER //
// src/components/Training/edit/index.vue